import { useMessageModal } from 'views/mutual/modal/messageModal/hooks';
import useOnceSubmit from 'views/utils/useOnceSubmit';
import { SubUserInfo, useDeleteSubUserMutation, useGetSubUserListQuery } from 'views/utils/graphql/graphql';
import { useGlobalToastHandler } from 'views/mutual/globalToast/hooks';

export const useSubUserList = () => {
  const { modalProps, showConfirmModal, showMessageModal } = useMessageModal();
  const { showError } = useGlobalToastHandler();
  const [subUserList, _reload] = useGetSubUserListQuery({
    requestPolicy: 'network-only',
  });
  const [_deleteSubUserResponse, deleteSubUser] = useDeleteSubUserMutation();

  const onDelete = useOnceSubmit<string>(
    {
      onPreviousSubmit: async () => {
        return await showConfirmModal('利用者を削除します', '削除', '閉じる');
      },
      onSubmit: async (branch: string) => {
        const res = await deleteSubUser({ input: { Branch: branch } });
        if (!res?.data) return;

        if (res.data.DeleteSubUser?.Code === 0) {
          showMessageModal('利用者を削除しました');
        } else {
          showError(res.data?.DeleteSubUser?.Message);
        }
        _reload();
      },
    },
    [],
  );

  return {
    subUserList,
    modalProps,
    onDelete,
  };
};
